export default __webpack_public_path__ + "static/media/OGJ-Type-Design-Sequel-Sans-Light-Body.a96ec5b2.woff";